<template>
  <q-dialog
    ref="jtCompositionModal"
    @show="onShowHandler"
    @hide="onHideHandler"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-large">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="edit" size="25px" />
            {{ $gettext(computedTitle) }}
          </q-toolbar-title>
          <q-btn flat @click="hide">
            <q-icon name="cancel" />
          </q-btn>
        </q-toolbar>
      </q-header>
      <q-page-container>
        <jt-dynamic-form
          v-if="form.dadosForm"
          ref="compositionForm"
          :inputs="customInputs"
          :buttons="form.buttons"
          :interface="form.nmInterface"
          :relacionamentos="form.relacionamentos"
          :model="form.dadosForm"
          form-class="form"
          style="padding: 30px"
          @form-button-click="actionButton"
        />
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtDynamicForm, JtCompositionFormModal } from 'jtech-webcomps'
import { messageBox } from 'src/jtech'
@Component({
  mixins: [JtCompositionFormModal],
  props: {
    form: {
      type: Object,
      required: true
    },
    composicaos: {
      type: Array,
      required: true
    },
    nrLinhaSelecionada: Number,
    flComposicaoAlteracao: Boolean
  }
})
class BillingOrderItem extends Vue {
  get customInputs () {
    const newInputs = this.form.inputs.map(i => {
      if (this.form.dadosForm?.replaceProduct) {
        if (i.name == 'description') i.readonly = true
      }
      if (i.name === 'quantity' || i.name === 'price') { i.length = 10000000 }
      return i
    })
    return newInputs
  }

  transformToDecimalWithDot (number) {
    const arrayChar = number.toString().split('')
    arrayChar.splice(number.length - 2, 0, '.')
    return Number(arrayChar.join(''))
  }

  get quantity () {
    const regexOnlyNumbers = /\D/gi
    const regexComma = /,/
    const regexDot = /\./
    let initQuantityString = this.form?.dadosForm?.quantity?.toString() || '0'
    if (initQuantityString?.includes('.') && initQuantityString?.includes(',')) {
      initQuantityString = initQuantityString.replace(/\./g, '')
    }
    const mediumQuantityString = initQuantityString.toString().replaceAll(',', '.')
    const formatPtBr = Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2
    })
    const finalQuantityString = formatPtBr.format(mediumQuantityString)
    return finalQuantityString.toString().replaceAll(regexOnlyNumbers, '')
  }

  get price () {
    const regexOnlyNumbers = /\D/gi
    const regexComma = /,/
    const regexDot = /\./
    let initPriceString = this.form?.dadosForm?.price.toString() || '0'
    if (initPriceString.includes('.') && initPriceString.includes(',')) {
      initPriceString = initPriceString.replace(/\./g, '')
    }
    const mediumPriceString = initPriceString.toString().replaceAll(',', '.')
    const formatPtBr = Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2
    })
    const finalPriceString = formatPtBr.format(mediumPriceString)
    return finalPriceString.toString().replaceAll(regexOnlyNumbers, '')
  }

  get product () {
    return this.form.dadosForm.product
  }

  get serviceType () {
    return this.form.dadosForm.serviceType
  }

  actionButton (props) {
    if (props.button.name == 'btSalvarComposicao') {
      if (parseFloat(props.fields.value) > 0) {
        this.onFormButtonClickHandler(props)
      } else {
        messageBox.error(this.$gettext('FIELD_CANT_BE_ZERO'))
      }
    } else {
      this.onFormButtonClickHandler(props)
    }
  }

  @Watch('form.dadosForm.product')
  onProductChange () {
    this.setDescription()
  }

  @Watch('form.dadosForm.serviceType')
  onServiceTypeChange () {
    this.setDescription()
  }

  setDescription () {
    if (this.form.dadosForm?.replaceProduct) {
      return
    }
    const labelServiceType = this.form.relacionamentos.serviceType.filter((item) => { return this.serviceType == item.value })[0]?.label
    const labelProduct = this.form.relacionamentos.product.filter((item) => { return this.product == item.value })[0]?.label
    this.form.dadosForm.description = `${labelServiceType || ''} ${labelProduct || ''}`
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  }

  @Watch('form.dadosForm.quantity')
  onQuantityChange () {
    this.calcValue()
  }

  @Watch('form.dadosForm.price')
  onPriceChange () {
    this.calcValue()
  }

  calcValue () {
    if (this.price && this.quantity) {
      const result = this.transformToDecimalWithDot(this.price) * this.transformToDecimalWithDot(this.quantity)
      this.form.dadosForm.value = result.toFixed(2)
    }
  }
}
export default BillingOrderItem
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
